import React from 'react';

import { StyleSheet } from 'react-native';

import { IBaseProps } from '@rbi-ctg/frontend';
import LoadingAnimation from 'components/loading-animation';
import { Box } from 'components/ui';
import { layout, spacing } from 'styles/constants';

interface ILoadingIndicatorProps extends IBaseProps {
  ariaLabel?: string;
}

export const LoadingIndicator = ({ ariaLabel }: ILoadingIndicatorProps) => {
  return (
    <Box testID="store-locator-loading" style={styles.container}>
      <LoadingAnimation ariaLabel={ariaLabel} />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    height: layout.full,
    justifyContent: 'center',
    margin: spacing.$0,
    width: layout.full,
  },
});
